// Lista de userIds permitidos para acesso ao backoffice
// Exporte este array para ser utilizado na verificação de acesso

export const userAccessIds = [
//   "8c9cbc74-5057-4543-8dc9-69ed4d22bef7",
  "082705a4-306f-499a-8cb7-ba7bee8d71bb",
  "31906ecf-5e93-485c-bd4e-9651809937b6",
  "0223fff2-0dbe-44b4-82f2-3c0c80fff592",
  "333a4b0f-3a3c-4ab6-a865-e298e71f9f6f",
  "39244886-3052-4c8b-ac6b-26855ab64410",
  "39b27084-95c2-46f6-8465-315892b32092",
  "52689cd2-5ac0-408e-9945-dcf88681641a",
  "54a76aea-70ac-4ff5-9740-4deb29cba6c0",
  "56a5cbd3-c36e-4c45-bf96-50799f1f6bc9",
  "593d57be-8d70-4fd3-b6ec-50d6114799be",
  "6607e590-24d5-40b9-9c7a-21af2a933a49",
  "6850f3d1-54d2-45f6-8315-d74618172560",
  "742fee97-cb7e-4760-87e2-063be9af00fe",
  "765b29b0-4940-40a2-81b5-28b0624a7d29",
  "76f2734c-7f0d-4c57-b3dd-8ba38fdebb73",
  "7b03bc31-d1be-4fc6-a2e0-2da226f4338c",
  "82b7419a-9fbc-48fc-8fc1-7ca9e5fa7a14",
  "9504864c-d351-4149-862a-0c38128132e6",
  "98fbe73e-c10e-44cc-9214-e3074dc1384e",
  "a1381a0d-a044-4f7d-9e55-c6ec7676f303",
  "98049208-6a29-4d32-abcf-14e0d5d5a0f8",
  "a8eb1f50-d008-432d-ae77-353e7b45b708",
  "a91ba4f0-bc66-48ab-b21b-2855c4bb8f37",
  "ab7b80fb-5715-4dc8-8ec0-4635f7a90c4f",
  "b21dc702-3218-403d-a245-3d36c52d04a4",
  "b8a7f4cc-fb95-4fa9-8a3f-2eb33ce46241",
  "bb06135e-5da1-49c3-891e-0563aff22394",
  "cbffaa6a-2056-4eeb-a938-8178e313d768",
  "cfa90d84-b9d7-406d-a0a1-771d42ca3fab",
  "d946f20a-40db-469e-98ab-a43d206c962a",
  "f0b418f1-d25f-468d-b22d-9086d12a88ad",
  "3748a5c1-5130-4fce-b038-95db2fc6aa3d",
  "35f56142-d371-4c24-bd52-a5ac4e4ee155",
  "4dea70be-8655-444e-9914-d75c7d998e61",
  "35b0630a-f462-4b92-948a-90a2a6c20c37",
  "3e33a79a-0f92-4705-9fcb-0560f0d5d484",
  "7842d104-0898-4c1d-aca1-fe6a1c314e3f",
  "4ddfea6c-48d0-4e4b-974a-d60f2500819b",
  "00c49790-a695-4935-bf20-46f88e017933",
  "85798254-0512-4fc1-976b-231c598cd558",
  "04fddfd7-70c1-4e5b-a7d7-a7e825ec9a44",
  "b0c2f11a-be8f-41f4-98f4-52d19293652c",
  "6af808cb-94d9-4973-8342-12788fd846e3",
  "65e63962-b420-4135-9ef3-2058b90602ca",
  "24ddc2a2-63ed-4cbc-ac69-85818576475d",
  "c8cee44d-ab06-4c15-93f1-dab9dfb14c05",
  "8973debc-1a50-43af-a51b-2103f45b8fa6",
  "a17e2a3b-06f9-452b-bcff-de98bd1ddae6",
  "967c89eb-3fa3-4b25-97c2-1af3bdf83b18",
  "1fd4f3d0-c24b-49c4-ab9d-1e10085d219e",
  "ca37b3df-2337-4307-ae25-1920a70f1818",
  "5301b7a0-0caa-434b-9d1f-1c2fc0194e27"
];